import { SiteState, PLACEHOLDER } from './types'

export default (state: SiteState = PLACEHOLDER) => state
